import React, {useState, useContext, useEffect, useRef, useCallback} from "react";
import {
    RealmContext,
    TokenContext,
    DataContext,
} from "../../Store";

import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";

import { trackPromise } from 'react-promise-tracker';

import http from "../../../shared/http-common";

import MaterialTable, { MTableToolbar } from "@material-table/core";
import FilterListIcon from '@mui/icons-material/FilterList';


import LoadingIndicator from "../../../shared/LoadingIndicator";
import {List, ListItem} from "@mui/material";
import DataObjectsEdit from "./DataObjectEdit";
import DataobjectService from "../../../services/DataobjectService";
import DataComponentEdit from "./DataComponentEdit";
import UploadDialog from "./UploadDialog";

import ObjecttypeSelectlist from "../../../shared/ObjecttypeSelectlist";

import UserService from "../../../services/UserService";

import { header } from'../../../shared/headerStyle';
import {useNavigate} from "react-router-dom";
import {useLocation} from "react-router";

// Style für DataTreeView
const styles = {
    root: {
        textAlign: "left",
        fontFamily: "poppins",
    },
    lightButton: {
        float: "right",
        fontWeight: "bold",
    },
    darkButton: {
        float: "right",
        color: "#e5e5e5",
        fontWeight: "bold",
    },
    katalogView: {
        width: "100%",
        height: "100%",
        float: "left",
    },
    btListe: {
        width: "100%",
        maxHeight: "100vh",
        float: "left",
    },

    table: {
        minWidth: 700,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
};


const GetObjectSubData = async (guid, objecttype, realm, token) => {
    try {
        let formData = new FormData();
        formData.append("realm", realm);
        formData.append("guid", guid);

        return await http.post(`/` + objecttype + `/getAllObjects`, formData,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            }
        });
    } catch (e) {
        console.error(e);
    }

}

const GetObjectData = async (realm, token) => {
    try {
        let formData = new FormData();
        formData.append("realm", realm);
        return await http.post(`/administrativeobject/economicunit/list`, formData,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            }
        });
    } catch (e) {
        console.error(e);
    }
};

const GetObjectDataByType = async (obejcttype, type, realm, token) => {
    try {
        let formData = new FormData();
        formData.append("realm", realm);
        return await http.post(`/` +obejcttype+`/` + type + `/list`, formData,{
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            }
        });
    } catch (e) {
        console.error(e);
    }
};


function DataobjectsListTable({dataObjects, handleObjecttypeChange, realm, token, setDataObjects}) {
    const data = useContext(DataContext);
    const setDataobjectsDialogOpen = data.setDialogOpen;
    const [dataObjectSelected, setDataObjectSelected] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [DataComponentEditDialogOpen, setDataComponentEditDialogOpen] = useState(false);
    const [DataComponentFormDialogOpen, setDataComponentFormDialogOpen] = useState(false);
    const [uploadDialogOpen, setUploadDialogOpen] = useState(false);

    const [filtering, setFiltering] = useState(false);
    const [tableDataId, setTableDataId] = useState(null);

    const tableRef = useRef();

    let navigate = useNavigate();


    const location = useLocation();

    const objectType = location?.state?.objectType;
    useEffect(() => {
        if(objectType) {
            putChangesInMotion(objectType)
        }
    }, [objectType])



    const handleEditClick = async (object) => {
        setIsLoading(true);
        if(object.administrativeobjectTypeGuid) {
            const result = await DataobjectService.getAdministrativeObject(token, realm, object.guid);
            setDataObjectSelected(result.data);
            setDataobjectsDialogOpen(true);
            setIsLoading(false);
        } else if(object.realestateobjectTypeGuid) {
            const result = await DataobjectService.getRealestateObject(token, realm, object.guid);
            setDataObjectSelected(result.data);
            setDataobjectsDialogOpen(true);
            setIsLoading(false);
        }
    }

    const handleDeactivateClick = async (object, event) => {
        event.preventDefault();
        setIsLoading(true);
        if(object.administrativeobjectTypeGuid) {
            await DataobjectService.deactivateAdministrativeobject(token, realm, object.guid);
            const bla = await GetObjectData(realm, token);
            setDataObjects([...bla.data]);
            setIsLoading(false);
        } else if(object.realestateobjectTypeGuid) {
            await DataobjectService.deactivateRealestateobject(token, realm, object.guid);
            const bla = await GetObjectData(realm, token);
            setDataObjects([...bla.data]);
            setIsLoading(false);
        }
    }

    const handleActivateClick = async (object, event) => {
        event.preventDefault();
        setIsLoading(true);
        if(object.administrativeobjectTypeGuid) {
            await DataobjectService.activateAdministrativeobject(token, realm, object.guid);
            const bla = await GetObjectData(realm, token);
            setDataObjects([...bla.data]);
            setIsLoading(false);
        } else if(object.realestateobjectTypeGuid) {
            await DataobjectService.activateRealestateobject(token, realm, object.guid);
            const bla = await GetObjectData(realm, token);
            setDataObjects([...bla.data]);
            setIsLoading(false);
        }
    }

    const handleComponentClick = (event, rowData) => {
        setDataObjectSelected(rowData);
        setDataComponentEditDialogOpen(true);
    }

    const handleUploadClick = (event, item) => {
        event.preventDefault();
        setDataObjectSelected(item);
        setDataobjectsDialogOpen(false);
        setDataComponentEditDialogOpen(false);
        setUploadDialogOpen(true);
    }

    let bauteilActionRO = {
        icon: 'hardware',
        tooltip: 'Bauteile',
        onClick: (event, rowData) => handleComponentClick(event, rowData),
    }
    let bauteilActionAO = '';

    const options = [
        {value: '', text: '-- Bitte wählen Sie einen Objekttypen --'},
        {value: 'territorialdivision', text: 'Gebietsgliederung'},
        {value: 'site', text: 'Liegenschaft'},
        {value: 'economicunit', text: 'Wirtschaftseinheit'},
        {value: 'parcel', text: 'Flurstück'},
        {value: 'structure', text: 'Bauwerk'},
        {value: 'building', text: 'Gebäude'},
        {value: 'storey', text: 'Geschoß'},
        {value: 'buildingentrance', text: 'Hauseingang'},
        {value: 'rentalunit', text: 'Mieteinheit'},
        {value: 'commercialunit', text: 'Gewerbeeinheit'},
        {value: 'apartment', text: 'Wohnung'},
        {value: 'room', text: 'Raum'},
        {value: 'playground', text: 'Spielplatz'},
        {value: 'parkingspace', text: 'Stellplatz'},
        {value: 'wastecollectionpoint', text: 'Müllstandplatz'},
    ];

    const [selected, setSelected] = useState(options[0].value);
    const [title, setTitle] = useState('Bitte wählen Sie einen Objekttypen');
    const [fieldType, setFieldType] = useState('administrativeobjectType');
    const [bauteilAction, setBauteilAction] = useState('');

    let hideDeactivatedColumn = true


    const handleChange = (event) => {
        putChangesInMotion(event.target.value);
    }

    const putChangesInMotion = (val) => {
        setSelected(val);
        let objecttype, type
        switch (val) {
            case 'site':
                objecttype = 'realestateobject';
                type = 'site';
                setTitle('Liegenschaften');
                setFieldType('realestateobjectType');
                setBauteilAction(bauteilActionRO);
                break;
            case 'structure':
                objecttype = 'realestateobject';
                type = 'structure';
                setTitle('Bauwerke');
                setFieldType('realestateobjectType');
                setBauteilAction(bauteilActionRO);
                break;
            case 'building':
                objecttype = 'realestateobject';
                type = 'building';
                setTitle('Gebäude');
                setFieldType('realestateobjectType');
                setBauteilAction(bauteilActionRO);
                break;
            case 'room':
                objecttype = 'realestateobject';
                type = 'room';
                setTitle('Räume');
                setFieldType('realestateobjectType');
                setBauteilAction(bauteilActionRO);
                break;
            case 'storey':
                objecttype = 'realestateobject';
                type = 'storey';
                setTitle('Etagen');
                setFieldType('realestateobjectType');
                setBauteilAction(bauteilActionRO);
                break;
            case 'playground':
                objecttype = 'realestateobject';
                type = 'playground';
                setTitle('Spielplätze');
                setFieldType('realestateobjectType');
                setBauteilAction(bauteilActionRO);
                break;
            case 'wastecollectionpoint':
                objecttype = 'realestateobject';
                type = 'wastecollectionpoint';
                setTitle('Müllstandplatz');
                setFieldType('realestateobjectType');
                setBauteilAction(bauteilActionRO);
                break;
            case 'economicunit':
                objecttype = 'administrativeobject';
                type = 'economicunit';
                setTitle('Wirtschafteinheiten')
                setFieldType('administrativeobjectType');
                setBauteilAction(bauteilActionAO);
                break;
            case 'apartment':
                objecttype = 'administrativeobject';
                type = 'apartment';
                setTitle('Wohnungen');
                setFieldType('administrativeobjectType');
                setBauteilAction(bauteilActionAO);
                break;
            case 'rentalunit':
                objecttype = 'administrativeobject';
                type = 'rentalunit';
                setTitle('Mieteinheiten');
                setFieldType('administrativeobjectType');
                setBauteilAction(bauteilActionAO);
                break;
            case 'commercialunit':
                objecttype = 'administrativeobject';
                type = 'commercialunit';
                setTitle('Gewerbeeinheiten');
                setFieldType('administrativeobjectType');
                setBauteilAction(bauteilActionAO);
                break;
            case 'parkingspace':
                objecttype = 'administrativeobject';
                type = 'parkingspace';
                setTitle('Stellplatzanlagen');
                setFieldType('administrativeobjectType');
                setBauteilAction(bauteilActionAO);
                break;
            case 'location':
            case 'buildingentrance':
                objecttype = 'administrativeobject';
                type = 'buildingentrance';
                setTitle('Hauseingänge');
                setFieldType('administrativeobjectType');
                setBauteilAction(bauteilActionAO);
                break;
            case 'parcel':
                objecttype = 'administrativeobject';
                type = 'parcel';
                setTitle('Flurstücke');
                setFieldType('administrativeobjectType');
                setBauteilAction(bauteilActionAO);
                break;
            case 'territorialdivision':
                objecttype = 'administrativeobject';
                type = 'territorialdivision';
                setTitle('Gebietsgliederungen');
                setFieldType('administrativeobjectType');
                setBauteilAction(bauteilActionAO);
                break;
            case 'washhouse':
                objecttype = 'administrativeobject';
                type = 'washhouse';
                setTitle('Waschhäuser');
                setFieldType('administrativeobjectType');
                setBauteilAction(bauteilActionAO);
                break;
            default:
                objecttype = 'administrativeobject';
                type = 'economicunit';
                setTitle('Wirtschaftseinheiten');
                setFieldType('administrativeobjectType');
                setBauteilAction(bauteilActionAO);
        }


        return handleObjecttypeChange(objecttype, type)
    };

    const getColumnType = () => {
        return fieldType;
    }


    if(filtering) {
        hideDeactivatedColumn = false;
    }


    const reloadObjects = () => {
        putChangesInMotion(selected)
            .then(() => {
                const theData = tableRef.current?.state?.renderData;
                if (theData instanceof Array) {
                    if (tableDataId !== null) {
                        const _data = [...dataObjects];
                        _data.forEach((item) => {
                            if (item.tableData.showDetailPanel) {
                                item.tableData.showDetailPanel = '';
                            }
                        });
                        if (_data[tableDataId]) {
                            _data[tableDataId].tableData = {
                                ..._data[tableDataId].tableData,
                                showDetailPanel: tableRef.current.props.detailPanel[0].render
                            }

                            setDataObjects(_data);
                        }
                    }
                }
            })
    }

    const tableHeight = `calc(100vh - ${88 + 74 + 56 + 52 + 0}px)`; // filter-bar + toolbar + col-header + pagination + padding

    const FilterToolbar = useCallback(
        (props) => (
            <>
                <MTableToolbar {...props} />
                <Button
                    variant="outlined"
                    size="small"
                    startIcon={<FilterListIcon />}
                    onClick={() => setFiltering(f => !f)}
                    style={{ position: 'absolute', right: '415px', top: '14px' }}
                >
                    Spaltenfilter
                </Button>
            </>
        ),
        [setFiltering]
    );

    return (
        <>

        <div className="page-filter-bar" style={{ background: 'rgb(240, 244, 248)', padding:'8px 5px' }}>

                <ObjecttypeSelectlist
                    options={options}
                    selected={selected}
                    handleChange={handleChange}
                    label="Objekt wählen"
                    style={{ minWidth: 260 }}
                />

        </div>
        <div style={{ padding: '12px', boxSizing: 'border-box', width: '100%' }}>
        <MaterialTable
            tableRef={tableRef}
            title={title}
            columns={[
                { title: 'Bezeichnung', field: 'name' },
                { title: 'Nummer', field: 'number'},
                { title: 'Kennzeichen', field: 'label' },
                { title: 'Typ', field: getColumnType()},
                { title: 'deaktiviert', field: 'deactivated', lookup: { 0: 'nein', 1: 'ja' }, hidden: hideDeactivatedColumn }
            ]}
            data={dataObjects}

            onRowClick={(event, rowData) => {
                    navigate('/Dataobject', {state: {subObjects: rowData, title: rowData.name, objectType: selected}})
                }
            }
            options={{
                headerStyle: header,
                rowStyle: rowData => ({
                    backgroundColor: (rowData.deactivated) ? '#EEE' : '#FFF',
                    display: (hideDeactivatedColumn && rowData.deactivated) ? 'none': ''
                }),
                pageSize: 10,
                pageSizeOptions: [10, 20, 50, 100],
                actionsColumnIndex: -1,
                filtering,
                exportButton: true,
                exportAllData: true,
                maxBodyHeight: tableHeight,
                minBodyHeight: tableHeight,
            }}
            components={{
                Container: props => <Paper {...props} style={{ ...props.style, position: 'relative' }} />,
                Toolbar: FilterToolbar,
            }}
            actions={[
                {
                    icon: 'edit',
                    tooltip: 'Editieren',
                    onClick: (event, rowData) => handleEditClick(rowData),
                    disabled: !UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN', 'TWIN_MANDANT_ADMIN', 'TWIN_DATA_WRITER', 'TWIN_DATA_ADMIN'])
                },
                rowData => ({
                    icon:  rowData.deactivated ? 'taskalt' : 'cancel',
                    tooltip: rowData.deactivated ? 'Aktivieren': 'Deaktivieren',
                    onClick: rowData.deactivated ? (event, rowData) => handleActivateClick(rowData, event) :(event, rowData) => handleDeactivateClick(rowData, event),
                    disabled: !UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN', 'TWIN_MANDANT_ADMIN', 'TWIN_DATA_WRITER', 'TWIN_DATA_ADMIN'])
                }),
                bauteilAction,
                {
                    icon: 'upload',
                    tooltip: 'Upload',
                    onClick: (event, rowData) => handleUploadClick(event, rowData),
                    disabled: !UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN', 'TWIN_MANDANT_ADMIN', 'TWIN_DATA_WRITER', 'TWIN_DATA_ADMIN'])
                }

            ]}
            isLoading={isLoading}
            localization={{
                pagination: {
                    labelDisplayedRows: '{from}-{to} von {count}',
                    labelRowsSelect: 'Zeilen',
                    labelRowsPerPage: 'Zeilen pro Seite'
                },
                toolbar: {
                    nRowsSelected: '{0} Zeile(n) ausgewählt',
                    searchTooltip: 'Suchen',
                    searchPlaceholder: 'Suchbegriff eingeben'
                },
                header: {
                    actions: 'Aktionen'
                },
                body: {
                    emptyDataSourceMessage: 'Keine Einträge gefunden',
                    filterRow: {
                        filterTooltip: 'Filter'
                    }
                }
            }}
        />
        </div>
            <DataObjectsEdit dataObjectSelected={dataObjectSelected}
                             handleDeactivateClick={handleDeactivateClick}
                             handleActivateClick={handleActivateClick}
                             reloadObjects={reloadObjects}
            />
            <DataComponentEdit
                dataObjectSelected={dataObjectSelected}
                setDataComponentEditDialogOpen={setDataComponentEditDialogOpen}
                DataComponentEditDialogOpen={DataComponentEditDialogOpen}
                handleUploadClick={handleUploadClick}
                setDataComponentFormDialogOpen={setDataComponentFormDialogOpen}
                DataComponentFormDialogOpen={DataComponentFormDialogOpen}
            />
            <UploadDialog
                dataObjectSelected={dataObjectSelected}
                setUploadDialogOpen={setUploadDialogOpen}
                uploadDialogOpen={uploadDialogOpen}
            />

        </>
    )
}

function DataobjectsList() {
    const [token] = useContext(TokenContext);
    const [realm] = useContext(RealmContext);

    const [dataObjects, setDataObjects] = useState([]);

    let navigate = useNavigate();

    useEffect(()=>{
        if(!UserService.isLoggedIn()) {
            UserService.doLogout();
            navigate('/');
        }
    }, []);

    const handleObjecttypeChange = (objecttype, type) => {
        return trackPromise(
            GetObjectDataByType(objecttype, type, realm, token).then((bla) => {
                setDataObjects(bla.data);
            }));
    };

    return (
        <div>
            <div className={styles.katalogView}>
                <LoadingIndicator/>
                <div className={styles.btListe}>

                        <DataobjectsListTable
                            dataObjects={dataObjects}
                            realm={realm}
                            token={token}
                            setDataObjects={setDataObjects}
                            handleObjecttypeChange={handleObjecttypeChange}
                        />

                </div>

            </div>

        </div>
    );
}

export default DataobjectsList;
